var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkykiIcn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 196,
    fill: "#1D273A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.8759 103.464H113.578C133.079 103.479 148.802 85.7974 146.833 66.066C145.559 53.2984 137.033 42.0951 125.198 37.6397C107.064 30.8123 86.1432 41.776 81.2616 61.0032C80.9672 61.0032 74.5486 61.004 74.2556 61.0059C67.1624 61.0511 60.5137 61.7305 55.1144 67.2214C51.1994 71.2029 49 76.6029 49 82.2335C49 93.7969 58.5055 103.464 69.8759 103.464Z",
    fill: "#00C3D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5874 126.781V133.619M123.341 126.781V133.619M74.5874 153.751V160.59M123.307 153.751V160.59M99.0426 126.781L93.6419 139.864L104.717 146.38L99.0426 160.59M141.896 140.457V146.722M53.9128 140.457V146.722M113.578 103.464H69.8759C58.5055 103.464 49 93.7969 49 82.2335C49 76.6029 51.1994 71.2029 55.1144 67.2214C60.5137 61.7305 67.1624 61.0511 74.2556 61.0059C74.5486 61.004 80.9672 61.0032 81.2616 61.0032C86.1432 41.776 107.064 30.8123 125.198 37.6397C137.033 42.0951 145.559 53.2984 146.833 66.066C148.802 85.7974 133.079 103.479 113.578 103.464Z",
    stroke: "#00C3D0",
    strokeWidth: 6.89062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkykiIcn);
export default __webpack_public_path__ + "static/media/skyki_icn.14a50182b0d0f562cf1cf665d23ef05b.svg";
export { ForwardRef as ReactComponent };